module.exports = __webpack_public_path__ + "assets/img/fr-818f1f5a.png";